import { showInfo } from '@/notifications'
import { H } from 'hennig-common'

window.generateOauthUrl = () => {
  H.rpc('Payment\\MercadoPago', 'generateOauthUrl', [], r => {
    console.log(r)
    showInfo('URL para autorização foi gerada')
  })
}
